import React from "react";
import PageSerch from "./SerchDocters/Components/PageSerch";
import DynamicBreadcrumbs from "../../Uitiles/DynamicBreadcrumbs";

const sections = [
  {
    title: "Overview",
    content: (
      <>
        Our refund and returns policy is applicable for <strong>30 days</strong> from the date of purchase. 
        If 30 days have passed since your purchase, we regret that we cannot offer a full refund or exchange.
        <blockquote>
          <p>
            <span role="img" aria-label="warning">⚠️</span> <strong>Please Note:</strong> All services offered 
            through MeddyList—such as doctor and hospital listings—are digital and subscription-based, and therefore non-refundable once activated.
          </p>
        </blockquote>
      </>
    ),
  },
  {
    title: "To Qualify for a Refund",
    content: (
      <ul>
        <li>The service was not activated or used.</li>
        <li>There was an error on our end during service provision.</li>
      </ul>
    ),
  },
  {
    title: "Non-Returnable / Non-Refundable Items",
    content: (
      <ul>
        <li>Gift cards</li>
        <li>Downloadable software or digital products</li>
        <li>Health and personal care items</li>
        <li>Custom services already rendered</li>
        <li><strong>Digital directory listings (doctors, hospitals, clinics, etc.)</strong></li>
        <li><strong>Activated subscription plans</strong></li>
      </ul>
    ),
  },
  {
    title: "Partial Refunds",
    content: (
      <ul>
        <li>Service issues caused by technical errors on our platform.</li>
        <li>Incorrect billing not caused by the user.</li>
      </ul>
    ),
  },
  {
    title: "Refund Process",
    content: (
      <>
        <p>We will notify you via email once your refund request has been reviewed and processed.</p>
        <p>
          <strong>Approved Refunds:</strong><br />
          Refunds will be credited to the original payment method within [X] business days.
        </p>
      </>
    ),
  },
  {
    title: "Delayed or Missing Refunds",
    content: (
      <ul>
        <li>Recheck your bank or credit card account</li>
        <li>Contact your payment provider</li>
        <li>If needed, email us at <a href="mailto:info@meddylist.com">info@meddylist.com</a></li>
      </ul>
    ),
  },
  {
    title: "Shipping Returns",
    content: (
      <p>
        <span role="img" aria-label="no-entry">🚫</span> <strong>No Physical Items Shipped – No Shipping Returns Required</strong><br />
        MeddyList is a digital platform and does not involve physical product shipping. Therefore, shipping returns and related policies do not apply.
      </p>
    ),
  },
  {
    title: "Exchanges",
    content: <p>Since all services are digital, exchanges are not applicable.</p>,
  },
  {
    title: "Gifts",
    content: <p>Digital services marked as gifts are non-refundable but may be credited to the recipient's account under certain conditions.</p>,
  },
  {
    title: "Need Help?",
    content: (
      <p>
        <span role="img" aria-label="phone">📞</span> Phone: 9705656070<br />
        <span role="img" aria-label="email">📧</span> Email: <a href="mailto:info@meddylist.com">info@meddylist.com</a>
      </p>
    ),
  },
];

const RefundReturns = () => {
  return (
    <div>
      <PageSerch />
      <DynamicBreadcrumbs />
      <main className="dc-main dc-haslayout">
        <div className="container">
          <div className="dc-parent-section">
            <div className="main-page-wrapper">
              <div className="dc-description">
                <p><strong>Effective Date:</strong> 07/01/2025</p>
                <p>
                  At MeddyList, we strive to provide excellent services and ensure customer satisfaction. 
                  Please review our refund and returns policy below for details about eligibility and the process.
                </p>

                {sections.map((section, index) => (
                  <div key={index} className="refund-section">
                    <hr />
                    <h3><strong>{section.title}</strong></h3>
                    <div>{section.content}</div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
};

export default RefundReturns;
